import React, { FC, useState } from 'react';
import VaultsAccordion from '@app/pages/passwordManager/components/vaultsList/accordion.component';
import { IVaultItem } from '@app/pages/passwordManager/interfaces';
import { IModalData, ModalComponent, OrganizationsSelect, PageLoader, PasslyButton } from '@app/components';
import { useTypedTranslation } from '@app/hooks';
import { Menu, MenuItem } from '@material-ui/core';
import { hasOrgPermission } from '@app/helpers';
import { ManageSystem, ManageVault } from '@app/store/constants';
import { useDispatch, useSelector } from 'react-redux';
import { getModalSwitch } from '@app/store/actions';
import { AddVaultDialog } from '@app/pages/passwordManager/components/dialogs/addVault.dialog';
import { AddFolderDialog } from '@app/pages/passwordManager/components/dialogs/addFolder.dialog';
import { IVaultPasswordPolicy } from '@app/models';

interface IVaultsSectionProps {
    onFolderChoose: (vault: string, folderId: string) => void;
    passwordPolicies: IVaultPasswordPolicy[];
    allVaults: IVaultItem[];
    vaultsReloaded: boolean;
    reloadAllVaults: Function;
    orgAllowedToViewThisPage: boolean;
    loadingVaultsData: boolean;
}

const VaultsSection: FC<IVaultsSectionProps> = ({ onFolderChoose, passwordPolicies, allVaults, vaultsReloaded, reloadAllVaults, orgAllowedToViewThisPage, loadingVaultsData }) => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const modalSwitchState: boolean = useSelector((state: any) => state.modal);
    const [modalData, setModalData] = useState<IModalData>({
        headerTitle: '',
        modalSwitcher: modalSwitchState
    });

    const chooseWhatToAdd = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const addVaultClick = () => {
        handleClose();
        dispatch(getModalSwitch(true));
        setModalData({
            headerTitle: translation('NEW_VAULT'),
            modalSwitcher: modalSwitchState,
            form: <AddVaultDialog handleRefresh={reloadAllVaults} passwordPolicies={passwordPolicies} allVaults={allVaults} />
        });
    };

    const addFolderClick = () => {
        handleClose();
        dispatch(getModalSwitch(true));
        setModalData({
            headerTitle: translation('NEW_FOLDER'),
            modalSwitcher: modalSwitchState,
            form: <AddFolderDialog handleRefresh={reloadAllVaults} allVaults={allVaults} />
        });
    };

    return (
        <>
            <ModalComponent {...modalData} />

            <div className='vaults__list-select'>
                <OrganizationsSelect enabledLocally withoutLabel fullWidth />
            </div>
            <div className='vaults__list-header'>
                <div>{translation('VAULT_UPPERCASE')}</div>
                <div>
                    {hasOrgPermission([ManageVault, ManageSystem]) && orgAllowedToViewThisPage && (
                        <>
                            <PasslyButton
                                id='verify'
                                additionalColor='tertiaryCTA'
                                className={`vaults__button-add ${anchorEl ? 'vaults__button-add-active' : ''}`}
                                onClick={chooseWhatToAdd}
                            >
                                {`+ ${translation('VAULT_ADD')}`}
                            </PasslyButton>
                            <Menu
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                className='vaults__menu-add'
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                                getContentAnchorEl={null}
                            >
                                <MenuItem onClick={addVaultClick}>{translation('ADD_VAULT')}</MenuItem>
                                <MenuItem onClick={addFolderClick}>{translation('ADD_VAULT_FOLDER')}</MenuItem>
                            </Menu>
                        </>
                    )}
                </div>
            </div>

            {orgAllowedToViewThisPage && allVaults ? (
                <>
                    <VaultsAccordion items={allVaults} onFolderChoose={onFolderChoose} itemsReloaded={vaultsReloaded} />
                    {!loadingVaultsData && allVaults.length === 0 ? <div className='table--empty'>{translation('VAULTS_EMPTY_LIST')}</div> : null}
                </>
            ) : (
                <div className='table--empty'>{translation('ORG_CANNOT_VIEW')}</div>
            )}

            {loadingVaultsData && <PageLoader useOverlay={true} isAbsolutePosition={true} />}
        </>
    );
};

export default VaultsSection;
